export default __webpack_public_path__ + "static/media/reports.ea54dbe6.svg";